export default __webpack_public_path__ + "static/media/Circle.cfb88f07.svg";